import { render } from "./Page404.vue?vue&type=template&id=36fa636a&scoped=true"
const script = {}

import "./Page404.vue?vue&type=style&index=0&id=36fa636a&lang=scss&scoped=true"

import exportComponent from "/Users/clopez/Documents/Repositorios/Muevetec/landing-muevetec-base/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36fa636a"]])

export default __exports__